<template>
  <div>
    <b-form @submit.prevent="onSubmit">
      <create-information
        ref="createGroupBannerInformation"
        :groupBannerInformation="groupBannerDetail.information"
        :loading="loading.information"
      />
      <create-mapping-banner
        ref="mappingBanner"
        :loading="loading.submit"
        :loadingMappingBanner="loading.information"
        :mappingBanner="groupBannerDetail.mappingBanner"
      />
      <b-col cols="12">
        <div class="content-mapping-action">
          <cancel-button class="mr-1" @click.native="$router.push('/banner/group/Banner_Group')" />
            <save-button
            :type="'submit'"
            :loading="loading.submit"
          />
        </div>
      </b-col>
    </b-form>
  </div>
</template>

<script>
import { BForm } from "bootstrap-vue";
import CreateInformation from "./CreateInformation.vue";
import CreateMappingBanner from "./CreateMappingBanner.vue";

import useGroupBannerCreateEditForm from "../hooks/useGroupBannerCreateEditForm";
import CancelButton from "@/views/components/button/CancelButton.vue";

export default {
  props: {
    isEdit: { type: Boolean, default: false },
  },
  components: { BForm, CreateInformation, CreateMappingBanner, CancelButton },

  setup(props) {
    const {
      loading,
      groupBannerDetail,
      onSubmit,
    } = useGroupBannerCreateEditForm(props);

    return { loading, groupBannerDetail, onSubmit };
  },
};
</script>

<style></style>
